export default __webpack_public_path__ + "static/media/3-3.da18c4f6.jpg";